import { createTheme, type Theme } from "@mui/material";
import { orange } from "@mui/material/colors";
import { breakpoints } from "./breakpoints";
import { darkModePalette, lightModePalette } from "./palette";
import { spacing } from "./spacing";
import { transitions } from "./transitions";
import { typography } from "./typography";

export enum ThemeVariantsProps {
  light = "light",
  dark = "dark",
}

declare module "@mui/material/styles" {
  interface Theme {
    status: {
      danger: string;
    };
  }
  interface ThemeOptions {
    status?: {
      danger?: string;
    };
  }
}
declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    c2color: true;
    c1color: true;
    b2color: true;
    b1color: true;
    a2color: true;
    a2fcolor: true;
    a1mcolor: true;
    pa1color: true;
    tficolor: true;
    ylecolor: true;
    backgroundColor: true;
  }
}

export const theme = (mode: ThemeVariantsProps) => {
  return createTheme({
    palette: {
      mode,
      ...(mode === "light" ? lightModePalette : darkModePalette),
    },
    typography,
    spacing: spacing as unknown as import("@mui/material").ThemeOptions["spacing"],
    breakpoints,
    transitions,
    status: {
      danger: orange[500],
    },
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: "#155380",
            fontSize: "0.9rem",
          },
          arrow: {
            color: "#155380",
          },
        },
      },
    },
  });
};

export const borderRadiusStandard = "40px";
export const borderRadiusCircle = "50%";

export const exerciseAnswerInputStyles = (theme: Theme, exerciseSent: boolean | undefined) => ({
  borderRadius: borderRadiusStandard,
  border: `3px solid ${theme.palette.mainOrangeInputColor.main}`,
  background: "white",
  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
  opacity: exerciseSent ? 1 : 0.65,
  "&:focus-within": { opacity: 1 },
});

export const getCloseButtonStyles = (theme: Theme) => ({
  borderRadius: "20px",
  textTransform: "none" as const,
  backgroundColor: "#ffebee",
  color: theme.palette.error.main,
  fontWeight: "medium",
  px: 2,
  py: 0.5,
  "&:hover": { backgroundColor: "#ffcdd2" },
});
